module.exports = __webpack_public_path__ + "static/media/Fahmida Cropped.512ff796.jpg";